/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope). */

/* No outer margin by design. Every consumer nests this in a gapped stack
   (VStack/Grid), and a margin here would add to that gap — the divider ended
   up 32px from the content below it (16px margin + 16px stack gap) rather
   than the intended 16px. Spacing around a section is the parent's job. */
.header {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}
